/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { initiatePaymentAsync } from './MyFatoorahPaymentDataActionExtension.g';
import { IInitiatePaymentResponse } from './MyFatoorahPaymentDataServiceEntities.g';
/**
 * GetMyFatoorahPaymentMethods Input Action
 */
export class GetMyFatoorahPaymentMethodsInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `MYFATOORAHPAYMENTMETHODS`;
    public getCacheObjectType = () => 'MYFATOORAHPAYMENTMETHODS';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetMyFatoorahPaymentMethodsData extends IInitiatePaymentResponse {
    text?: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetMyFatoorahPaymentMethodsInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetMyFatoorahPaymentMethodsInput, ctx: Msdyn365.IActionContext): Promise<IGetMyFatoorahPaymentMethodsData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    try{
        const paymentCurrencyISO = ctx.requestContext.app.config.paymentCurrencyISO || "AED" ;
        const paymentMethodList = await initiatePaymentAsync({callerContext: ctx},1,paymentCurrencyISO)
        return paymentMethodList;
    }catch(error){
        console.log(error)
        return { 
            IsSuccess: false,
            Message: "Something went wrong.",
            Data: {},
        }
    }
    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetMyFatoorahPaymentMethodsData[]>('/get/example/id/1', 'get');
    // return { text: 'Static data from action' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetMyFatoorahPaymentMethodsData>>action,
    // TODO: Give your data action a unique id
    id: 'GetMyFatoorahPaymentMethods',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
